import axios, {AxiosResponse} from 'axios'
import {SaleReportsQueryResponse} from './_models'
import {Option} from 'react-multi-select-component'
import {Response, SearchReportsSales} from '../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/reports`
const SALE_URL = `${API_URL}/sales`
const PRODUCTS_URL = `${API_URL}/products`
const FILE_URL = `${API_URL}/files`

const getSaleReports = (query: string): Promise<SaleReportsQueryResponse> => {
  return axios
    .get(`${REPORTS_URL}/sale-items?${query}`)
    .then((d: AxiosResponse<SaleReportsQueryResponse>) => d.data)
}

const getSaleStatus = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${SALE_URL}/statuses?all=1`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const getCategories = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${PRODUCTS_URL}/categories/all`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const getAvailableProducts = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${REPORTS_URL}/available-products`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const downloadServerFile = async (
  filter: string | undefined
): Promise<{message: string; id: number} | void> => {
  var filterAdjust = filter !== undefined ? `?${filter}` : ''
  const response = await axios({
    url: `${REPORTS_URL}/sale-items/export${filterAdjust}`,
    method: 'GET',
    responseType: 'blob',
  })

  const contentType = response.headers['content-type'] ?? ''

  if (contentType.includes('application/json')) {
    const text = await (response.data as Blob).text()
    return JSON.parse(text) as {message: string; id: number}
  }

  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', 'Relatorio_vendas.xlsx')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export {getSaleReports, getSaleStatus, getCategories, getAvailableProducts, downloadServerFile}
